import React from 'react';
import { CircularProgress } from '@mui/material';
import CommonContext from '../Common';
import {
    FlexStartRow,
    FlexEndRow
} from '../common/forms/FormElements';
import * as moment from 'moment';

export class SignatureReviewTableAll extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
        };
    }

    componentDidMount() {
        this.populateState();
    }

    async populateState() {
        this.setState({
            loading: false,
        });
    }

    render() {

        var hourlyTimesheets = this.props.hourlyTimesheets;
        var tonnageTimesheets = this.props.tonnageTimesheets;

        const hoursTotal = this.props.hoursTotal;
        const tonnageHoursTotal = this.props.tonnageHoursTotal;
        const tonnageTotal = this.props.tonnageTotal;

        var inGroup = false;

        if (this.state.loading) {
            return (<CircularProgress color="secondary" variant="indeterminate" />);
        }
        return (
            <>
                <FlexStartRow>
                    <div className="overviewStats">
                        <table style={{ width: '100%' }}>
                            <tr>
                                <td class="overviewStatsHeader" align="right" width="70">Hourly:</td>
                                <td align="right" width="70">&nbsp;{hoursTotal.toFixed(2)} hrs</td>
                                <td class="overviewStatsTotal" align="center">{(hoursTotal + tonnageHoursTotal).toFixed(2)} Hours</td>
                            </tr>
                            <tr>
                                <td class="overviewStatsHeader" align="right">Tonnage:</td>
                                <td align="right">&nbsp;{tonnageHoursTotal.toFixed(2)} hrs</td>
                                <td class="overviewStatsTotal" align="center">{tonnageTotal.toLocaleString()} Tons</td>
                            </tr>

                        </table>
                    </div>
                </FlexStartRow>

                <h4 style={{ marginTop: '16px', marginBottom: '0px' }}>
                    <FlexStartRow>Hourly Tickets</FlexStartRow>
                    <FlexEndRow>
                        <span style={{ fontSize: '14px' }}>Hours</span>
                    </FlexEndRow>
                </h4>

                <table width="100%">
                    <tbody>
                        {!(hourlyTimesheets ?? [])
                            .length ? (
                                <tr>
                                    <td
                                        colSpan="4"
                                        className="text-center"
                                    >
                                        No tickets found.
                                    </td>
                                </tr>
                            ) : (
                                hourlyTimesheets.map(
                                    (timesheet, i) => {

                                        const sequence = timesheet.linkedTimesheetSequence == null ? '' : '-' + timesheet.linkedTimesheetSequence;

                                        var timeSpan = '';
                                        if (timesheet.startTime != null)
                                            timeSpan += moment(timesheet.startTime).format('h:mm a');

                                        if (timeSpan.length > 0) timeSpan += ' - ';

                                        if (timesheet.endTime != null)
                                            timeSpan += moment(timesheet.endTime).format('h:mm a');

                                        return (
                                            <>
                                                <tr key={timesheet.id}>
                                                    <td style={{ paddingTop: '8px' }} className="d-flex flex-row align-items-start">
                                                        <span className="site-link">
                                                            {`${timesheet.jobNumber}${sequence}`}
                                                        </span>
                                                        &nbsp;&nbsp;
                                                        <span style={{ padding: '2px', fontSize: '12px' }}>{timeSpan}</span>
                                                    </td>

                                                    <td align="right" width="100">
                                                        {timesheet.value?.toFixed(2)}
                                                    </td>
                                                </tr>

                                                
                                                <tr style={{ borderBottom: '2px solid lightgray' }}>

                                                    {timesheet.loads?.length > 0 &&
                                                        <td colspan="2">
                                                            <table style={{ marginLeft: '20px' }}>
                                                                {timesheet.loads.map((load) => {

                                                                    return (
                                                                        <tr style={{ fontSize: '12px' }}>
                                                                            <td width="200">{load.material}</td>

                                                                            {load.loads == 1 &&
                                                                                <td>{load.loads} load</td>
                                                                            }
                                                                            {load.loads > 1 &&
                                                                                <td>{load.loads} loads</td>
                                                                            }
                                                                        </tr>
                                                                    );
                                                                })}
                                                              
                                                            </table>
                                                        </td>
                                                    }
                                                </tr>

                                                

                                            </>
                                        );
                                    },
                                )
                            )}
                    </tbody>
                </table>

                <h4 style={{ marginTop: '16px', marginBottom: '0px' }}>
                    <FlexStartRow>Tonnage Tickets</FlexStartRow>
                    <FlexEndRow>
                        <span style={{ fontSize: '14px' }}>Tons</span>
                    </FlexEndRow>
                </h4>

                <table width="100%">
                    <tbody>
                        {!(tonnageTimesheets ?? [])
                            .length ? (
                                <tr>
                                    <td
                                        colSpan="4"
                                        className="text-center"
                                    >
                                        No tickets found.
                                    </td>
                                </tr>
                            ) : (

                                tonnageTimesheets.map(
                                    (timesheet, i) => {

                                        const sequence = timesheet.linkedTimesheetSequence == null ? '' : '-' + timesheet.linkedTimesheetSequence;

                                        var timeSpan = '';
                                        if (timesheet.startTime != null)
                                            timeSpan += moment(timesheet.startTime).format('h:mm a');

                                        if (i > 0 && timesheet.startTime == tonnageTimesheets[i - 1].startTime && timesheet.endTime == null)
                                            timeSpan = '';

                                        if (timeSpan.length > 0 && timesheet.endTime != null) timeSpan += ' - ';

                                        if (timesheet.endTime != null)
                                            timeSpan += moment(timesheet.endTime).format('h:mm a');

                                        var grouped = 'tonnageNonGrouping';
                                        if (timesheet.startTime != null) {
                                            inGroup = true;
                                        }

                                        if (inGroup)
                                            grouped = 'tonnageGrouping';

                                        if (timesheet.endTime != null) {
                                            inGroup = false;
                                        }

                                        if (i > 0 && tonnageTimesheets[i - 1].endTime == null && timesheet.endTime != null)
                                            timeSpan = moment(timesheet.endTime).format('h:mm a');

                                        return (
                                            <>
                                                <tr className={grouped} key={timesheet.id}>
                                                    <td style={{ paddingTop: '8px', paddingBottom: '8px' }} className="d-flex flex-row align-items-start">
                                                        <span className="site-link">
                                                            {`${timesheet.jobNumber}${sequence}`}
                                                        </span>
                                                        &nbsp;&nbsp;
                                                        <span style={{ padding: '2px', fontSize: '12px' }}>{timeSpan}</span>
                                                    </td>

                                                    <td align="left" width="200">
                                                        <span style={{ fontSize: '12px' }}>{timesheet.material}</span>
                                                    </td>
                                                    
                                                    <td align="right" width="100">
                                                        {timesheet.value}
                                                    </td>
                                                </tr>

                                                {timesheet.endTime != null &&
                                                    <tr><td>&nbsp;</td></tr>
                                                }
                                            </>
                                        );
                                    },
                                )
                            )}
                    </tbody>
                </table>
            </>
        );
    }
}

SignatureReviewTableAll.contextType = CommonContext;
